/** @module Enums */ /** typedoc */
/**
 * dollar-sign currencies country codes (http://www.xe.com/symbols.php#section3)
 * - ARS: Argentina Peso
 * - AUD: Australia Dollar
 * - BSD: Bahamas Dollar
 * - BBD: Barbados Dollar
 * - BMD: Bermuda Dollar
 * - BND: Brunei Darussalam Dollar
 * - CAD: Canada Dollar
 * - KYD: Cayman Islands Dollar
 * - CLP: Chile Peso
 * - COP: Colombia Peso
 * - XCD: East Caribbean Dollar
 * - SVC: El Salvador Colon
 * - FJD: Fiji Dollar
 * - GYD: Guyana Dollar
 * - HKD: Hong Kong Dollar
 * - LRD: Liberia Dollar
 * - MXN: Mexico Peso
 * - NAD: Namibia Dollar
 * - NZD: New Zealand Dollar
 * - SGD: Singapore Dollar
 * - SBD: Solomon Islands Dollar
 * - SRD: Suriname Dollar
 * - TVD: Tuvalu Dollar
 * - USD: United States Dollar
 */
var DollarSignCurrenciesEnum;
(function (DollarSignCurrenciesEnum) {
    DollarSignCurrenciesEnum["ARS"] = "ARS";
    DollarSignCurrenciesEnum["AUD"] = "AUD";
    DollarSignCurrenciesEnum["BSD"] = "BSD";
    DollarSignCurrenciesEnum["BBD"] = "BBD";
    DollarSignCurrenciesEnum["BMD"] = "BMD";
    DollarSignCurrenciesEnum["BND"] = "BND";
    DollarSignCurrenciesEnum["CAD"] = "CAD";
    DollarSignCurrenciesEnum["KYD"] = "KYD";
    DollarSignCurrenciesEnum["CLP"] = "CLP";
    DollarSignCurrenciesEnum["COP"] = "COP";
    DollarSignCurrenciesEnum["XCD"] = "XCD";
    DollarSignCurrenciesEnum["SVC"] = "SVC";
    DollarSignCurrenciesEnum["FJD"] = "FJD";
    DollarSignCurrenciesEnum["GYD"] = "GYD";
    DollarSignCurrenciesEnum["HKD"] = "HKD";
    DollarSignCurrenciesEnum["LRD"] = "LRD";
    DollarSignCurrenciesEnum["MXN"] = "MXN";
    DollarSignCurrenciesEnum["NAD"] = "NAD";
    DollarSignCurrenciesEnum["NZD"] = "NZD";
    DollarSignCurrenciesEnum["SGD"] = "SGD";
    DollarSignCurrenciesEnum["SBD"] = "SBD";
    DollarSignCurrenciesEnum["SRD"] = "SRD";
    DollarSignCurrenciesEnum["TVD"] = "TVD";
    DollarSignCurrenciesEnum["USD"] = "USD";
})(DollarSignCurrenciesEnum || (DollarSignCurrenciesEnum = {}));

export { DollarSignCurrenciesEnum };
